import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Box, Button, Grid, Typography } from "@mui/material";
import MuiInputField from "../../Components/InputField/InputField";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import useLogin from "./useLogin";
import validator from "validator";

const useStyles = makeStyles((theme) => ({
  root: {
    background: `linear-gradient(to bottom,#bdfef6, #fafbce)`,
    /* Other styles for your web page */
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  db: {
    backgroundColor: "black",
    width: "40px",
    color: "white",
    height: "25px",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "10px",
  },
}));

const LoginPage = ({ setIsLogin }) => {
  const classes = useStyles();
  const state = useLogin(setIsLogin);

  const [usernameError, setUsernameError] = useState(""); // State for username validation error
  const [passwordError, setPasswordError] = useState(""); // State for password validation error
  const [showPassword, setShowPassword] = useState(false); // Show password

  // Validation function for username
  const validateUsername = (value) => {
    if (validator.isEmpty(value)) {
      setUsernameError("Username is required");
    } else {
      setUsernameError("");
    }
  };

  // Validation function for password
  const validatePassword = (value) => {
    if (validator.isEmpty(value)) {
      setPasswordError("Password is required");
    } else {
      setPasswordError("");
    }
  };

  // Function to handle login button click
  const userLogin = () => {
    // Perform validation before login
    validateUsername(state.username);
    validatePassword(state.password);

    // Proceed with login only if there are no validation errors
    if (!usernameError && !passwordError) {
      state.loginUser();
    }
  };

  useEffect(() => {
    localStorage.setItem("isLogin", "false");
  }, []);

  return (
    <div className={classes.root}>
      <Box
        sx={{
          backgroundColor: "white",
          boxShadow: " rgba(149, 157, 165, 0.2) 0px 8px 24px",
          borderRadius: "15px",
          padding: "70px",
        }}
        width={450}
        height={450}
      >
        <Grid item alignItems="center" container>
          <Typography fontSize={"30px"}>Kare</Typography>
          <div className={classes.db}>DB</div>
        </Grid>
        <Grid marginY="20px" item>
          <Typography color="grey">
            Home to everything about Mykare Health's expanding network of
            doctors and hospitals.
          </Typography>
        </Grid>
        <Grid marginY="20px" item>
          <Typography>User Name</Typography>
          <MuiInputField
            type="text"
            onChange={(event) => {
              state.setUsername(event.target.value);
            }}
            value={state.username}
            placeHolder={"User name"}
          />
          {usernameError && (
            <Typography marginTop={1} color={"red"} fontSize={"14px"}>
              {usernameError}
            </Typography>
          )}
        </Grid>
        <Grid item marginY="20px">
          <Typography>Password</Typography>
          <div style={{ position: "relative" }}>
            <MuiInputField
              type={showPassword ? "text" : "password"}
              onChange={(event) => {
                state.setPassword(event.target.value);
              }}
              value={state.password}
              placeHolder={"Password"}
            />
            <Box onClick={() => setShowPassword(!showPassword)}>
              <>
                {showPassword ? (
                  <VisibilityOffIcon
                    style={{ position: "absolute", right: 10, top: 10 }}
                  />
                ) : (
                  <VisibilityIcon
                    style={{ position: "absolute", right: 10, top: 10 }}
                  />
                )}
              </>
            </Box>
          </div>
          {passwordError && (
            <Typography marginTop={1} color={"red"} fontSize={"14px"}>
              {passwordError}
            </Typography>
          )}
        </Grid>
        <Grid>
          <Button
            onClick={() => {
              userLogin();
            }}
            sx={{
              backgroundColor: "#17dfbabe",
              width: "100%",
              height: "50px",
              borderRadius: "10px",
              marginTop: "20px",
              ":hover": { backgroundColor: "#17dfba" },
            }}
          >
            <Typography textTransform="capitalize" color="white">
              Login
            </Typography>
          </Button>
        </Grid>
      </Box>
    </div>
  );
};

export default LoginPage;
